export default __webpack_public_path__ + "static/media/img_2.1629f9a4.png";